import pxToRem from 'assets/theme/function/px-to-rem';
import { breakpoints } from 'assets/theme/base/breakpoints';

const dialogContent = {
    styleOverrides: {
        root: {
            paddingTop: pxToRem(40),
            paddingBottom: pxToRem(20),
            paddingLeft: pxToRem(20),
            paddingRight: pxToRem(20),
            //color: white.main,

            [breakpoints.down('md')]: {
                paddingLeft: pxToRem(35),
                paddingRight: pxToRem(35),
            },

            [breakpoints.down('sm')]: {
                paddingTop: pxToRem(30),
                paddingLeft: pxToRem(10),
                paddingRight: pxToRem(10),
            },
        },
    },
};

export default dialogContent;
